import React, { useContext } from 'react';
import { capitalize } from 'lodash';
import { SubsContext } from '../Billsby/SubscriptionInfo';
import { isFeatureEnabled } from '../../config/featureFlags';

const MySubscriptionLevel = () => {
  const { subscriptionLevel } = useContext(SubsContext);
  if (subscriptionLevel && isFeatureEnabled('ENABLE_BILLSBY')) {
    return (<span><br />Subscription: {capitalize(subscriptionLevel)}</span>);
  }
  return <span />;
}

export default MySubscriptionLevel;


// WEBPACK FOOTER //
// ./src/components/Subscription/MySubscriptionLevel.jsx